var map = {
	"./icon-007.png": "9b379",
	"./icon-away.png": "4a61",
	"./icon-ball.png": "07fc",
	"./icon-disney.png": "a4b1",
	"./icon-donkey.png": "849d",
	"./icon-doom.png": "71c5",
	"./icon-final.png": "c566",
	"./icon-finished.png": "3c60",
	"./icon-harry.png": "6b7e",
	"./icon-lotr.png": "640b",
	"./icon-mario.png": "de32",
	"./icon-mega.png": "9810",
	"./icon-off.png": "2fdb",
	"./icon-onn.png": "bac2",
	"./icon-paused.png": "50a3",
	"./icon-pending.png": "a8ce",
	"./icon-played.png": "222a",
	"./icon-playing.png": "c367",
	"./icon-pokemon.png": "d23e",
	"./icon-skate.png": "996b",
	"./icon-tetris.png": "1f80",
	"./icon-zelda.png": "4224",
	"./icon-zombie.png": "f8a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07a0";